<template>
  <div
    id="check-details"
    :class="{ loaded: orderLoading }"
    v-if="selectedOrder !== null"
  >
    <div class="header_action">
      <div class="main-action">
        <button
          :class="
            'def-btn secondary-action-btn big border-2 medium icon left uppercase ' +
            design
          "
          @click="goBack()"
        >
          <icon-component iconName="backTo" />
        </button>
        <p>Check #{{ selectedOrder.public_code }}</p>
      </div>

      <div v-if="isResetingOrder" class="reset_action">
        <base-button
          @onClick="cancelResetingOrder"
          text="cancel"
          classes="def-btn cancel main-action-btn uppercase medium border-2"
        />
        <base-button
          @onClick="resetOrder"
          text="save"
          classes="def-btn main-action-btn uppercase medium border-2"
        />
      </div>
    </div>

    <div class="loader" v-if="orderLoading">
      <icon-component iconName="loader" />
    </div>

    <div v-if="!orderLoading" class="content">
      <div class="block block_1">
        <p class="title">Order:</p>
        <table v-if="isDefaultOrder" class="table table_1">
          <thead>
            <tr>
              <th class="th_item">ITEM</th>
              <th class="th_price">PRICE</th>
              <th class="th_q">QTY</th>
              <th class="th_disc">DISCOUNT</th>
              <th class="th_tax">TAX</th>
              <th class="th_total">TOTAL</th>
            </tr>
          </thead>

          <tbody>
            <template
              v-for="(item, index) in selectedOrder.items"
              :key="item.id ?? index"
            >
              <tr>
                <td class="td_name">
                  {{ item.name }}
                </td>

                <td>
                  {{ item.price.toFixed(2) }}
                </td>

                <td>
                  {{ item.count }}
                </td>

                <td v-if="selectedOrder.status === 1">
                  <base-button
                    @onClick="
                      $emit(
                        'setItemDiscount',
                        'setDiscountGratuityModalRef',
                        {
                          title: 'Item discount',
                          index: index,
                        }
                      )
                    "
                    :text="calcDiscount(item)"
                    classes="
                      def-btn
                      disc
                      secondary-action-btn
                      icon
                    "
                    customStyles="color: black"
                  />
                </td>

                <td v-else>
                  {{
                    item.m_discount_amount
                      ? item.m_discount_amount.toFixed(2)
                      : "0.00"
                  }}
                </td>

                <td class="td_tax">
                  {{ formatMoney(item?.tax_amount) }}
                </td>

                <td class="td_total">
                  {{ item.total.toFixed(2) }}
                </td>
              </tr>

              <tr
                v-for="itemCondiment in getDisplayedCondiments(
                  item?.condiments
                )"
                :key="itemCondiment.id"
              >
                <td class="td_name">
                  <span class="condiment-name">
                    {{
                      itemCondiment
                        ?.menu_item_condiment
                        ?.menu_item
                        ?.name
                    }}
                  </span>
                </td>

                <td>
                  {{ parseFloat(itemCondiment.price)?.toFixed(2) }}
                </td>

                <td>
                  <span class="condiment-qty">
                    {{ itemCondiment.count }}
                  </span>
                </td>

                <td class="item-discount"></td>

                <td class="td_tax">
                  {{ formatMoney(itemCondiment?.tax_amount) }}
                </td>

                <td class="td_total">
                  {{ parseFloat(itemCondiment.total)?.toFixed(2) }}
                </td>
              </tr>
            </template>

            <tr class="totals">
              <td colspan="3" class="td_name">
                TOTAL:
              </td>

              <td>
                {{ calcTotalDisc() }}
              </td>

              <td class="td_tax">
                {{ taxAmountFormatted }}
              </td>

              <td class="td_total">
                {{ selectedOrder.subtotal?.toFixed(2) }}
              </td>
            </tr>
          </tbody>
        </table>

        <table v-if="isPackagePlanOrder" class="table table_1">
          <thead>
            <tr>
              <th class="th_package-plan-item">ITEM</th>
              <th class="th_package-plan-payer">Payer</th>
              <th class="th_package-plan-price">PRICE</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in selectedOrder.items">
              <td class="td_name">{{ item.name }}</td>
              <td class="td_name">
                {{ item?.user_profile?.first_name }}
                {{ item?.user_profile?.last_name }}
              </td>
              <td class="td_total">{{ parseFloat(item.price).toFixed(2) }}</td>
            </tr>

            <tr class="totals">
              <td colspan="2" class="td_name">TOTAL:</td>
              <td class="td_total">{{ selectedOrder.subtotal?.toFixed(2) }}</td>
            </tr>
          </tbody>
        </table>

        <package-plans
          :order="selectedOrder"
          :user="selectedOrder?.payers?.[0] ?? null"
          @selected:change="changeSelectedPackagePlan"
        />

        <p class="title">Check info:</p>
        <table class="table table_3">
          <thead>
            <tr>
              <th class="th_name"></th>
              <th class="th_vals"></th>
              <!-- <th class="th_actions"></th>
						<th class="th_actions_2"></th> -->
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="td_name">SUBTOTAL:</td>
              <td class="td_vals">
                {{
                  isItemDiscountLevel
                    ? selectedOrder.original_subtotal.toFixed(2)
                    : selectedOrder.subtotal.toFixed(2)
                }}
              </td>
              <!-- <td class="td_actions"></td>
						<td class="td_actions"></td> -->
            </tr>
            <tr v-if="isItemDiscountLevel">
              <td class="td_name">DISCOUNTS:</td>
              <td class="td_vals">-{{ totalOrderItemsDiscount }}</td>
            </tr>
            <tr v-if="!isItemDiscountLevel">
              <td class="td_name">DISCOUNTS:</td>
              <td class="td_vals">{{ totalOrderDiscount }}</td>
              <!-- <td class="td_actions"> -->
              <!-- <Switch
								v-if="selectedOrder.status === 1"
								:val="selectedOrder.with_discount"
								@toggled="(value) => $emit('toggleDiscount', value)"
							/> -->
              <!-- </td>
						<td class="td_actions">
							<base-button	@onClick="this.$emit('showDiscountDetails')" text="DETAILS" classes="def-btn secondary-action-btn uppercase medium border-2" />
						</td> -->
            </tr>
            <!-- <tr>
						<td class="td_name">TAX:</td>
						<td class="td_vals">{{ selectedOrder.tax ? selectedOrder.tax.toFixed(2) : '0.00' }}</td>
						<td class="td_actions"></td>
						<td class="td_actions"></td>
					</tr> -->
            <tr>
              <td class="td_name">TAX:</td>
              <td class="td_vals">{{ taxAmountFormatted }}</td>
            </tr>
            <tr>
              <td class="td_name">ADDITIONAL TIP:</td>
              <td class="td_vals">
                {{
                  selectedOrder.gratuity_amount
                    ? selectedOrder.gratuity_amount.toFixed(2)
                    : "0.00"
                }}
              </td>
              <!-- <td class="td_actions"></td>
						<td class="td_actions"></td> -->
            </tr>
            <tr>
              <td class="td_name">AUTO GRATUITY:</td>
              <td class="td_vals">
                {{
                  selectedOrder.auto_gratuity_amount
                    ? selectedOrder.auto_gratuity_amount.toFixed(2)
                    : "0.00"
                }}
              </td>
              <!-- <td class="td_actions"></td>
						<td class="td_actions"></td> -->
            </tr>
            <tr class="totals">
              <td class="td_name">TOTAL:</td>
              <td class="td_vals">{{ selectedOrder.total.toFixed(2) }}</td>
              <!-- <td class="td_actions"></td>
						<td class="td_actions"></td> -->
            </tr>
          </tbody>
        </table>
      </div>

      <div class="block block_2">
        <p class="title">Details:</p>
        <table class="table table_2">
          <thead>
            <tr>
              <th class="th_name"></th>
              <th class="th_vals"></th>
              <th class="th_actions"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="isDefaultOrder">
              <td class="td_name">TABLE:</td>
              <td class="td_vals">{{ selectedOrder.table }}</td>
              <td class="td_actions">
                <base-button
                  v-if="selectedOrder.status === 1"
                  @onClick="$emit('changeTable')"
                  text="CHANGE"
                  classes="def-btn secondary-action-btn uppercase medium border-2"
                />
              </td>
            </tr>
            <tr>
              <td class="td_name">OPENED BY:</td>
              <td class="td_vals">{{ selectedOrder.opened_by.name }}</td>
              <td class="td_actions"></td>
            </tr>
            <tr>
              <td class="td_name">OPENING DATE:</td>
              <td class="td_vals">{{ selectedOrder.created_at }}</td>
              <td class="td_actions"></td>
            </tr>
            <tr v-if="selectedOrder.status !== 3">
              <td class="td_name">SERVING BY:</td>
              <td class="td_vals">{{ selectedOrder.serviced_by.name }}</td>
              <td class="td_actions">
                <base-button
                  v-if="
                    isDefaultOrder ||
                    (isPackagePlanOrder && selectedOrder.status === 1)
                  "
                  :classes="
                    userRole === 'waiter assist'
                      ? 'def-btn secondary-action-btn uppercase medium border-2 disabled'
                      : 'def-btn secondary-action-btn uppercase medium border-2'
                  "
                  @onClick="changingServing"
                  text="CHANGE"
                />
              </td>
            </tr>
            <tr v-if="selectedOrder.status !== 1">
              <td class="td_name">CLOSED BY:</td>
              <td class="td_vals">{{ selectedOrder.closed_by?.name }}</td>
              <td class="td_actions"></td>
            </tr>
            <tr v-if="selectedOrder.status !== 1">
              <td class="td_name">POSTING DATE:</td>
              <td class="td_vals">{{ selectedOrder.closed_at }}</td>
              <td class="td_actions"></td>
            </tr>
            <tr v-if="selectedOrder.status === 3 && selectedOrder?.adjusted_at">
              <td class="td_name">ADJUSTMENT DATE:</td>
              <td class="td_vals">{{ selectedOrder?.adjusted_at ?? "" }}</td>
              <td class="td_actions"></td>
            </tr>
          </tbody>
        </table>

        <p
          v-if="
            selectedOrder.status === 1 ||
            (selectedOrder.status === 2 && isResetingOrder)
          "
          class="title"
        >
          Payment method:
        </p>
        <table
          v-if="
            selectedOrder.status === 1 ||
            (selectedOrder.status === 2 && isResetingOrder)
          "
          class="table table_4"
        >
          <thead>
            <tr>
              <th class="th_name"></th>
              <th class="th_actions"></th>
            </tr>
          </thead>
          <tbody>
            <tr
              :class="selectedOrder.payment_type === 1 ? 'sel' : ''"
              @click="$emit('toggleCPT', 1)"
            >
              <td class="td_name">Cabin/Crew charge</td>
              <td class="td_actions">
                <icon-component
                  v-if="selectedOrder.payment_type === 1"
                  iconName="chosen"
                />
              </td>
            </tr>
            <tr
              :class="selectedOrder.payment_type === 2 ? 'sel' : ''"
              @click="
                isDefaultOrder && $emit('toggleCPT', 2), (showKaypad = true)
              "
            >
              <td class="td_name">House account</td>
              <td class="td_actions">
                <icon-component
                  v-if="selectedOrder.payment_type === 2"
                  iconName="chosen"
                />
              </td>
            </tr>
          </tbody>
        </table>

        <div
          class="payers"
          v-if="selectedOrder.payment_type === 2"
          @click="showKaypad = true"
        >
          <div class="payers-header">House account number:</div>
          <input
            v-model.trim="selectedOrder.payment_house_account_number"
            class="input-houseAccount"
            @input="
              setHouseAccountInput(
                $event.target.value.replace(/[^0-9]/g, ''),
                true,
              )
            "
            oninput="this.value = this.value.replace(/[^0-9]/g, '')"
          />
        </div>

        <p v-if="selectedOrder.payment_type !== 2" class="title">Payers:</p>
        <table v-if="selectedOrder.payment_type !== 2" class="table table_5">
          <thead>
            <tr>
              <th class="th_name">NAME</th>
              <th class="th_param">ALC. DRINKS</th>
              <th class="th_param">CABIN</th>
              <th class="th_param">ID GET</th>
              <th class="th_param">TOTAL</th>
              <th
                :class="selectedOrder.status !== 1 ? 'th_actions' : 'th_param'"
              >
                PAYMENT
              </th>
              <th
                v-if="
                  selectedOrder.status === 1 ||
                  (selectedOrder.status === 2 && isResetingOrder)
                "
                class="th_actions"
              >
                DELETE
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(payer, index) in selectedOrder.payers"
              :class="[
                {
                  ends:
                    payer.alcohol_count_per_day_available !== 'unlimited' &&
                    payer.alcohol_count_per_day_available <= 1,
                },
              ]"
            >
              <td class="td_name">{{ getFullName(payer) }}</td>
              <td>{{ getUsedAlcoholDrinks(payer) }}</td>
              <td>{{ payer.cabin }}</td>
              <td>{{ payer.addition_mode?.name }}</td>
              <td class="td_total">{{ payer.total?.toFixed(2) }}</td>
              <td :class="selectedOrder.status !== 1 ? 'td_actions' : ''">
                {{ getPaymentMethods }}
              </td>
              <td
                v-if="
                  selectedOrder.status === 1 ||
                  (selectedOrder.status === 2 && isResetingOrder)
                "
                class="td_actions"
              >
                <button
                  :disabled="isPackagePlanOrder"
                  :class="['def-btn', 'del', 'secondary-action-btn', 'icon']"
                  @click="$emit('deletePayer', index)"
                >
                  <icon-component v-if="isDefaultOrder" iconName="delete" />
                  <icon-component
                    v-if="isPackagePlanOrder"
                    iconName="deleteDisabled"
                  />
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <base-button
          v-if="
            (selectedOrder.status === 1 && selectedOrder.payment_type === 1) ||
            (selectedOrder.status === 2 &&
              isResetingOrder &&
              selectedOrder.payment_type === 1)
          "
          @onClick="
            $emit('addPayer', 'payersModalRef', {
              modalTitleText: 'Add payer',
              modalSubmitBtnText: 'Add',
            })
          "
          imgSrc="plus"
          text="ADD PAYER"
          classes="def-btn secondary-action-btn uppercase medium border-2 icon left"
          :is-disabled="maxUserLimitExceeded"
        />

        <p v-if="selectedOrder.status === 3" class="title">Cancellation:</p>
        <table v-if="selectedOrder.status === 3" class="table table_6">
          <thead>
            <tr>
              <th class="th_name"></th>
              <th class="th_vals"></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="td_name">CANCELLED BY:</td>
              <td class="td_vals">{{ selectedOrder.opened_by?.name }}</td>
            </tr>
            <tr>
              <td class="td_name">DATE:</td>
              <td class="td_vals">{{ cancellationDate }}</td>
            </tr>
            <tr>
              <td class="td_name">REASON:</td>
              <td class="td_vals">{{ cancellationReason }}</td>
            </tr>
            <tr>
              <td class="td_name">COMMENT:</td>
              <td class="td_vals">{{ selectedOrder.comment }}</td>
            </tr>
            <tr v-if="selectedOrder?.pos_activity_log">
              <td class="td_name">ACTIVITY LOG:</td>
              <td
                class="td_vals"
                v-html="
                  selectedOrder?.pos_activity_log?.replace(
                    new RegExp('\r?\n', 'g'),
                    '<br />',
                  )
                "
              ></td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="block block_3">
        <p class="title">Actions:</p>
        <div class="btns">
          <base-button
            v-if="
              isDefaultOrder && (selectedOrder.status === 1 || isResetingOrder)
            "
            @onClick="$emit('editDiscounts')"
            imgSrc="editDiscount"
            text="EDIT DISCOUNTS"
            classes="def-btn secondary-action-btn uppercase medium border-2 icon left"
          />

          <base-button
            v-if="
              !isRetailMode && (selectedOrder.status === 1 || isResetingOrder)
            "
            @onClick="$emit('addGratuity')"
            imgSrc="plus"
            :text="addTipTitle"
            classes="def-btn secondary-action-btn uppercase medium border-2 icon left"
          />

          <base-button
            v-if="!isResetingOrder"
            @onClick="$emit('printCheck')"
            imgSrc="printCheck"
            text="SERVICE CHECK"
            classes="def-btn secondary-action-btn uppercase medium border-2 icon left"
          />

          <base-button
            v-if="
              (isPackagePlanOrder && selectedOrder.status === 1) ||
              (isDefaultOrder && selectedOrder.status !== 3 && !isResetingOrder)
            "
            :isDisabled="userRole !== 'manager'"
            imgSrc="cancelOrder"
            text="CANCEL CHECK"
            classes="def-btn cancel main-action-btn uppercase medium border-2 icon left"
            @onClick="startCancelOrder"
          />

          <base-button
            v-if="selectedOrder.status === 1"
            :isDisabled="userRole === 'waiter assist'"
            imgSrc="closeOrderWh"
            text="CLOSE CHECK"
            classes="def-btn main-action-btn uppercase medium border-2 icon left"
            @onClick="startCloseOrder"
          />

          <base-button
            v-if="
              isDefaultOrder && selectedOrder.status === 2 && !isResetingOrder
            "
            :isDisabled="userRole === 'waiter assist'"
            imgSrc="reopenOrder"
            text="REOPEN ORDER"
            classes="def-btn cancel-action-btn uppercase medium border-2 icon left"
            @onClick="startReopenOrder"
          />

          <base-button
            v-if="selectedOrder.status === 2 && !isResetingOrder"
            :isDisabled="userRole === 'waiter assist' || cantAdjustOrder"
            @onClick="resetingOrder"
            imgSrc="resetOrder"
            text="adjust closed check"
            :classes="`def-btn cancel-action-btn uppercase medium border-2 icon left ${
              cantAdjustOrder ? 'disabled' : ''
            }`"
          />
          <span
            v-if="
              selectedOrder.status === 2 && !isResetingOrder && cantAdjustOrder
            "
            class="adjust-caption"
          >
            Closed check can only be modified one time.
          </span>
        </div>

        <Keypad
          v-if="selectedOrder.payment_type === 2 && showKaypad"
          class="keypad"
          :dot="false"
          :smaller="true"
          @clickOnKey="setHouseAccountInput"
          @clear="clearHouseAccountInput"
          @close="showKaypad = false"
        />
      </div>

      <confirmation-modal-component
        class="adjust-confirmation-modal"
        ref="adjust-confirmation-modal"
        @onConfirmationModalConfirm="confirmAdjustOrder"
      />

      <confirmation-modal-component
        class="adjust-confirmation-modal"
        ref="payers-has-discount-modal"
        :has-cancel-btn="false"
      />
    </div>
  </div>
</template>

<script>
import Switch from "@/components/_shared/Switch.vue";
import { constants } from "@/constants/constants";
import BaseButton from "@/components/_shared/Button.vue";
import iconComponent from "@/components/_shared/Icon.vue";
import Keypad from "@/components/_shared/Keypad";
import store from "@/store";
import {
  calculateTotalDiscount,
  calculateTotalItemsDiscount,
  calculateItemDiscountInAmount,
  getDisplayedCondiments,
  getButtonTipTitle,
} from "@/_helpers/order";
import ConfirmationModalComponent from "@/components/_shared/ConfirmationModal.vue";
import CommentModal from "@/components/_modals/CommentModal.vue";
import CustomCheckbox from "../../components/_shared/CustomCheckbox.vue";
import PackagePlans from "../../components/_shared/PackagePlans.vue";
import { orderService } from "../../_api/order.api";
import { formatDataService } from "../../_helpers/format-data";
import { init as initSettings } from "@/_helpers/settings";
import { settingsService } from "@/_api/settings.api";

export default {
  name: "CheckDetailsComponent",
  props: {
    selectedOrder: {
      require: false,
      type: Object,
    },
    section: {
      require: false,
      type: String,
    },
    orderLoading: {
      require: false,
      type: Boolean,
      default: false,
    },
  },
  emits: [
    "backToPos",
    "changeTable",
    "changeServing",
    "editDiscounts",
    "addGratuity",
    "printCheck",
    "cancelOrder",
    "closeOrder",
    "setItemDiscount",
    "showDiscountDetails",
    "deletePayer",
    "resetOrder",
    "reopenOrder",
    "addPayer",
    "toggleCPT",
    "houseAccountInputChange",
    "cancelResetingOrder",
    "packagePlan:change",
  ],
  components: {
    PackagePlans,
    CustomCheckbox,
    CommentModal,
    ConfirmationModalComponent,
    Switch,
    BaseButton,
    iconComponent,
    Keypad,
  },
  data() {
    return {
      paymentMethods: constants.paymentMethods,
      isResetingOrder: false,
      showKaypad: false,
      // houseAccountInput: '',
    };
  },
  computed: {
    isItemDiscountLevel() {
      return this.selectedOrder?.department?.discount_level !== 2;
    },

    addTipTitle() {
      return getButtonTipTitle(this.selectedOrder);
    },

    isPackagePlanOrder() {
      return this.selectedOrder.type === "PP";
    },
    isDefaultOrder() {
      return !this.isPackagePlanOrder;
    },
    design() {
      return this.$store.state.UI;
    },
    getPaymentMethods() {
      let pm = this.paymentMethods.find(
        (el) => el.id === this.selectedOrder.payment_type,
      );
      if (pm) {
        return pm.name;
      }
      return "";
    },
    maxUserLimitExceeded() {
      return this.selectedOrder.payers.length >= constants.maxPayers;
    },
    userRole() {
      return this.$store.state.auth.user?.user.role;
    },
    totalOrderDiscount() {
      return calculateTotalDiscount(this.selectedOrder);
    },
    totalOrderItemsDiscount() {
      return calculateTotalItemsDiscount(this.selectedOrder);
    },
    taxAmountFormatted() {
      return this.formatMoney(this.selectedOrder?.tax_amount);
    },

    cancellationReason() {
      return (
        constants.cancellationReason?.[this.selectedOrder?.reason_type]
          ?.reason ?? ""
      );
    },

    cancellationDate() {
      const dateFieldName =
        constants.cancellationReason?.[this.selectedOrder?.reason_type]
          ?.date_field ?? "";
      if (!dateFieldName) {
        return "";
      }

      return this.selectedOrder?.[dateFieldName] ?? "";
    },

    cantAdjustOrder() {
      return !!this.selectedOrder?.adjusted_at;
    },

    orderPayersHasDiscount() {
      return (
        2 === this.selectedOrder.status &&
        this.selectedOrder?.payers.some((payer) => payer?.has_discounts)
      );
    },
    isRetailMode() {
      return this.$store.state.auth?.posData?.department?.retail_mode;
    },
  },
  created() {},
  mounted() {
    settingsService
      .getSettings()
      .then((res) => {
        initSettings(this.$store, res.data);
      })
      .catch((err) => {
        console.error(err);
      });
  },
  beforeUnmount() {},
  beforeDestroy() {},
  methods: {
    getDisplayedCondiments,

    formatMoney(value) {
      const num = parseFloat(value);

      return Number.isFinite(num)
        ? num.toFixed(2)
        : "0.00";
    },

    changeSelectedPackagePlan(profileId) {
      this.$emit(
        "packagePlan:change",
        profileId,
      );
    },

    changingServing() {
      if (this.userRole === "waiter assist") {
        store.dispatch(
          "alert/error",
          "User does not have access privileges",
        );
      } else {
        this.$emit("changeServing");
      }
    },

    clearHouseAccountInput() {
      this.$emit(
        "houseAccountInputChange",
        this.selectedOrder
          .payment_house_account_number
          .slice(0, -1),
      );
    },
    setHouseAccountInput(e, fromInp) {
      if (fromInp) {
        this.selectedOrder.payment_house_account_number = e;
      } else {
        this.selectedOrder.payment_house_account_number += e;
      }
      this.$emit(
        "houseAccountInputChange",
        this.selectedOrder.payment_house_account_number,
      );
    },
    goBack() {
      if (this.section === "POS") {
        this.$emit("backToPos", false);
      } else {
        this.$router.replace({ path: `/checks` });
      }
      /*if (this.selectedOrder && this.selectedOrder.id) {
				this.$emit('backToPos', false);
			} else {
				this.$router.replace({path: `/checks`})
			}*/
    },
    getFullName(payer) {
      let name = "";
      if (payer.first_name) name += payer.first_name;
      if (payer.middle_name) name += ` ${payer.middle_name}`;
      if (payer.last_name) name += ` ${payer.last_name}`;
      return name;
    },
    // calcTotalQty() {
    // 	let total = 0;
    // 	this.selectedOrder.items.forEach(el => total += el.count);
    // 	return total;
    // },
    calcTotalDisc() {
      let total = 0;
      this.selectedOrder.items.forEach(
        (el) => (total += parseFloat(this.calcDiscount(el))),
      );
      return parseFloat(total).toFixed(2);
    },
    resetingOrder() {
      if (this.orderPayersHasDiscount) {
        this.showWarningPayerDiscountModal();
        return;
      }

      this.isResetingOrder = true;

      if (!this.selectedOrder.payment_type) {
        this.selectedOrder.payment_type = 1;
      }
    },
    cancelResetingOrder() {
      this.isResetingOrder = false;
      this.$emit("cancelResetingOrder");
    },
    resetOrder() {
      this.$refs["adjust-confirmation-modal"].show({
        message: `Closed check can only be modified one time. Proceed with changes?`,
        okButton: "Yes",
        cancelButton: "No",
      });
    },
    showWarningPayerDiscountModal() {
      this.$refs["payers-has-discount-modal"].show({
        message:
          "Check is not allowed to be modified due to the limitations on the Fidelio side (it includes Fidelio discount)",
        okButton: "OK",
      });
    },
    confirmAdjustOrder() {
      this.isResetingOrder = false;
      this.$emit("resetOrder");
    },
    // toggleDiscount(value) {
    // 	this.$emit('toggleDiscount', value)
    // }
    calcDiscount(item) {
      return calculateItemDiscountInAmount(item);
    },
    startCancelOrder() {
      if (this.userRole !== "manager") {
        return;
      }

      if (this.orderPayersHasDiscount) {
        this.showWarningPayerDiscountModal();
        return;
      }

      this.$emit("cancelOrder");
    },

    startCloseOrder() {
      if (this.orderPayersHasDiscount) {
        this.showWarningPayerDiscountModal();
        return;
      }

      this.$emit("closeOrder");
    },

    startReopenOrder() {
      if (this.orderPayersHasDiscount) {
        this.showWarningPayerDiscountModal();
        return;
      }

      this.$emit("reopenOrder");
    },

    getUsedAlcoholDrinks(payer) {
      const needShowAlcoholDrinksCount = Boolean(
        payer?.age <= 0 ||
          payer?.age >= this.$store.getters.legalAge.ADDITION_LEGAL_AGE_ALCOHOL,
      );

      if (!needShowAlcoholDrinksCount) {
        return "-";
      }

      const maxAvailable = this.$store.getters.limitAlcoholPerDay;

      if (
        maxAvailable > 0 &&
        payer?.alcohol_count_per_day_available !== "unlimited"
      ) {
        return maxAvailable - (payer?.alcohol_count_per_day_available ?? 0);
      }

      return "-";
    },
  },
  watch: {},
};
</script>

<style lang="less" scoped>
#check-details {
  padding-right: 12px;
  height: calc(100% - 12px);
  margin-left: 0;
  transition-property: margin-left;
  transition-timing-function: ease-in-out;
  transition-duration: 300ms;

  .header_action {
    // margin-top: 12px;
    padding-top: 12px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    .main-action {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 18px;

      button {
        width: 60px;
        height: 60px;

        img {
          margin: 0;
        }
      }

      p {
        margin: 0;
        padding: 0;
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        letter-spacing: 0.15px;
        color: #1c282d;
      }
    }

    .reset_action {
      display: flex;
      flex-direction: row;
      gap: 18px;

      .def-btn {
        width: 118px;
        height: 60px;
      }
      .cancel {
        background: #eb262b;
        border-color: #eb262b;
      }
    }
  }

  .content {
    margin-top: 12px;
    height: calc(100% - 80px);
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    // overflow-y: hidden;
    .block {
      padding: 24px 12px;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      background: #ffffff;
      box-shadow: 0px 0.3px 0.9px rgba(0, 0, 0, 0.1),
        0px 1.6px 3.6px rgba(0, 0, 0, 0.14);
      border-radius: 8px;
      overflow-y: auto;

      &::-webkit-scrollbar {
        display: none;
      }

      .title {
        margin: 0;
        padding: 0;
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        text-align: center;
        color: #1c282d;
      }

      .table {
        width: 100%;
        table-layout: fixed;
        border-collapse: collapse;
        box-sizing: border-box;
        text-align: left;

        tr {
          th {
            padding: 2px;
            text-align: center;
          }
        }

        tbody {
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          color: #1c282d;

          tr {
            td {
              padding: 2px;
            }
          }
        }
      }

      &_1 {
        flex: 2;

        .table_1 {
          margin: 12px 0 48px;

          thead {
            font-style: normal;
            font-weight: 600;
            font-size: 12px;
            color: #1c282d;

            tr {
              height: 36px;

              th {
                border: 1px solid #e5e0eb;
                // border-bottom: 1px solid #E5E0EB;
                // border-left: 1px solid #E5E0EB;
              }

              .th_item {
                width: 30%;
                border-left: none;
              }

              .th_price {
                width: 15%;
              }

              .th_q {
                width: 10%;
              }

              .th_disc {
                width: 15%;
              }

              .th_tax {
                width: 15%;
              }

              .th_total {
                border-right: none;
                width: 15%;
              }

              .th_package-plan-item {
                border-left: none;
                width: 55%;
              }

              .th_package-plan-price {
                width: 15%;
                border-right: none;
              }

              .th_package-plan-payer {
                width: 30%;
              }
            }
          }

          tbody {
            tr {
              height: 36px;

              td {
                border: 1px solid #e5e0eb;
                text-align: right;

                .disc {
                  padding: 10px 0;
                  margin: 0 auto;
                  width: 100%;
                  height: 36px;
                  border-color: #d9e8f3;
                  border-radius: 8px;

                  span {
                    color: #1c282d;
                  }
                }
              }

              .td_name {
                border-left: none;
                text-align: left;

                .condiment-name {
                  padding-left: 20px;
                }
              }

              .td_total {
                border-right: none;
              }
            }

            .totals {
              font-style: normal;
              font-weight: 700;
              font-size: 14px;
              color: #1c282d;
            }
          }
        }

        .table_3 {
          margin: 12px 0 36px;

          thead {
            tr {
              .th_name {
                width: 30%;
              }

              .th_vals {
                width: 10%;
              }

              .th_actions {
                width: 25%;
              }

              .th_actions_2 {
                width: 20%;
              }
            }
          }

          tbody {
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            color: #1c282d;

            tr {
              td {
                height: 40px;
                border-top: 1px solid #e5e0eb;
                border-bottom: 1px solid #e5e0eb;
              }

              .td_name {
                border-left: none;
                font-style: normal;
                font-weight: 600;
                font-size: 12px;
                color: #1c282d;
              }

              .td_vals {
                text-align: right;
              }

              .td_actions {
                text-align: right;

                .def-btn {
                  width: 82px;
                  height: 28px;
                  margin: 0 auto;
                }
              }
            }

            .totals {
              font-style: normal;
              font-weight: 700;
              font-size: 14px;
              color: #1c282d;

              td {
                border-top: 2px solid #e5e0eb;
                border-bottom: none;
              }

              .td_name {
                font-weight: 700;
              }
            }
          }
        }
      }

      &_2 {
        flex: 2;
        .table_2 {
          margin: 12px 0 48px;

          thead {
            tr {
              .th_name {
                width: 30%;
              }

              .th_vals {
                width: 50%;
              }

              .th_actions {
                width: 20%;
                min-width: max-content;
              }
            }
          }

          tbody {
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            color: #1c282d;

            tr {
              td {
                height: 40px;
                border-top: 1px solid #e5e0eb;
                border-bottom: 1px solid #e5e0eb;
              }

              .td_name {
                border-left: none;
                font-style: normal;
                font-weight: 600;
                font-size: 12px;
                color: #1c282d;
              }

              .td_actions {
                .def-btn {
                  width: 82px;
                  height: 28px;
                  margin-left: auto;
                  margin-right: 0;
                }
              }
            }

            .totals {
              font-style: normal;
              font-weight: 700;
              font-size: 14px;
              color: #1c282d;
            }
          }
        }

        .table_4 {
          margin: 12px 0 36px;

          thead {
            tr {
              .th_name {
                width: calc(100% - 30px);
              }

              .th_actions {
                width: 30px;
              }
            }
          }

          tbody {
            font-weight: 400;
            font-size: 16px;

            tr {
              cursor: pointer;

              td {
                height: 40px;
                // border-top: 1px solid #E5E0EB;
                border-bottom: 1px solid #e5e0eb;
              }

              .td_name {
                border-left: none;
              }

              .td_actions {
                align-items: end;

                .def-btn {
                  width: 82px;
                  height: 28px;
                }
              }
            }

            .sel {
              background: #f5f9fc;
            }
          }
        }

        .table_5 {
          margin: 12px 0 24px;

          thead {
            font-style: normal;
            font-weight: 600;
            font-size: 12px;
            color: #1c282d;

            tr {
              height: 36px;

              th {
                border: 1px solid #e5e0eb;
                // border-bottom: 1px solid #E5E0EB;
                // border-left: 1px solid #E5E0EB;
              }

              .th_name {
                width: 30%;
                border-left: none;
              }

              .th_param {
                width: 14%;
              }

              .th_actions {
                width: 14%;
                border-right: none;
              }
            }
          }

          tbody {
            tr {
              height: 36px;

              td {
                border: 1px solid #e5e0eb;
              }

              .td_name {
                border-left: none;
              }

              .td_total {
                text-align: right;
              }

              .td_actions {
                border-right: none;

                .del {
                  margin: 0 auto;
                  width: 54px;
                  height: 36px;
                  border-color: #d9e8f3;
                  border-radius: 8px;
                }
              }
            }
          }
        }

        .table_6 {
          margin: 12px 0 12px;

          thead {
            tr {
              .th_name {
                width: 30%;
              }

              .th_vals {
                width: 70%;
              }
            }
          }

          tbody {
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            color: #1c282d;

            tr {
              td {
                height: 40px;
                border-top: 1px solid #e5e0eb;
                border-bottom: 1px solid #e5e0eb;
              }

              .td_name {
                border-left: none;
                font-style: normal;
                font-weight: 600;
                font-size: 12px;
                color: #1c282d;
              }

              .td_vals {
                align-items: end;
              }
            }
          }
        }

        .def-btn {
          width: 276px;
          height: 36px;
          padding: 12px;

          img {
            width: 18px;
            height: 18px;
          }

          span {
            font-weight: 600;
            font-size: 16px;
          }
        }

        .payers {
          margin-bottom: 40px;

          .payers-header {
            font-style: normal;
            font-weight: 600;
            font-size: 18px;
            line-height: 24px;
            text-align: center;
            color: #1c282d;
          }

          .input-houseAccount {
            padding: 0 10px;
            border: none;
            border-bottom: 2px solid #3f8ec5;
            font-size: 20px;
            max-width: 150px;
            width: 100%;
          }
        }
      }

      &_3 {
        position: relative;
        flex: 1;
        min-width: 310px;
        overflow-y: hidden;
        overflow-x: hidden;

        .btns {
          margin-top: 12px;
          display: flex;
          flex-direction: column;
          gap: 24px;

          .def-btn {
            width: 276px;
            height: 36px;
            padding: 12px;

            img {
              width: 22px;
              height: 22px;
            }

            span {
              font-weight: 600;
              font-size: 16px;
            }
          }
        }

        .cancel {
          background: #eb262b;
          border-color: #eb262b;
        }

        .keypad {
          position: absolute;
          height: 252px;
          width: 302px;
          bottom: 8px;
          left: 50%;
          margin: 10px auto 0 auto;
          transform: translate(-50%, 0);
          .flex-row {
            padding: 4px !important;
          }
        }
      }
    }
  }
}

#check-details.loaded {
  margin-left: -100px;
  transition-property: margin-left;
  transition-timing-function: ease-in-out;
  transition-duration: 300ms;
}

.adjust-caption {
  font-size: 14px;
}

:deep(.adjust-confirmation-modal) {
  .c-modal .window .message {
    font-size: 36px;
    font-weight: 300;
    padding: 15px;
  }
}

.ends {
  background-color: #fdeced;
}
</style>

<style scoped>
#check-details{height:100%;min-height:0;box-sizing:border-box;padding:0;display:flex;flex-direction:column}
#check-details .header_action{padding:0;flex-shrink:0;min-height:56px}
#check-details .header_action .main-action button{width:48px;height:48px}
#check-details .content{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr) minmax(260px,.7fr);min-height:0;flex:1;height:auto;align-items:stretch}
#check-details .content .block{min-width:0;min-height:0;width:auto;height:auto;box-sizing:border-box;padding:16px 10px;overflow:auto}
#check-details .content .block_3 .btns{width:100%}
#check-details .content .block_3 button{max-width:100%;white-space:normal;height:auto;min-height:40px}
@media(max-width:1100px){
 #check-details .content{grid-template-columns:minmax(0,1fr) minmax(0,1fr);overflow:auto;align-content:start}
 #check-details .content .block{overflow:visible}
 #check-details .content .block_3{grid-column:1/-1;grid-row:1}
 #check-details .content .block_3 .btns{display:flex;flex-direction:row;flex-wrap:wrap;gap:8px;justify-content:center}
 #check-details .content .block_3 button{width:auto;flex:1 1 160px;margin:0}
}
@media(max-width:700px){#check-details .content{grid-template-columns:minmax(0,1fr)}}
</style>
